import { useEffect } from 'react'

export function useHandleScroll(disabled: boolean) {
  useEffect(() => {
    if (disabled) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = 'auto'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [disabled])
}
